import { createAction } from 'redux-actions';
import * as productDataReviewWizardTypes from './productDataReviewWizardTypes';

export const loadProductReviewData = createAction(productDataReviewWizardTypes.LOAD_PRODUCT_REVIEW_DATA);

export const updateProductDataReview = createAction(productDataReviewWizardTypes.UPDATE_PRODUCT_REVIEW_DATA);
